import React, { useEffect } from 'react';

export const Store = React.createContext();

const storageKey = 'gh.adminGc';

const localStorageData = localStorage.getItem(storageKey);
let localState;
if (localStorageData) {
  localState = JSON.parse(localStorageData);
}

const initialState = {
  dashboard: {
    data: [],
    fetched: null
  },
  notifications: {
    data: [],
    unRead: null,
    fetched: null
  },
  restrictions: {
    data: [],
    fetched: null
  },
  adminContact: {
    data: {},
    fetched: null
  },
  settings: {
    version: '0.0.0',
    versionLastChecked: null
  },
  unhandledWebSales: {
    number: null,
    fetched: null
  },
  releaseInformation: {
    shown: null
  },
  golfamoreInformation: {
    shown: null
  }
};

function reducer(state, action) {
  // console.log('action.type', action.type, action.payload);
  switch (action.type) {
    case 'NOTIFICATIONS_FETCHED':
      return {
        ...state,
        notifications: {
          data: action.payload.notifications,
          unRead: action.payload.unRead,
          fetched: Date.now()
        }
      };
    case 'DASHBOARD_FETCHED':
      return {
        ...state,
        dashboard: {
          data: action.payload,
          fetched: Date.now()
        }
      };
    case 'RELEASE_INFORMATION_SHOWN':
      return {
        ...state,
        releaseInformation: { shown: action.payload }
      };
    case 'GOLFAMORE_INFORMATION_SHOWN':
      return {
        ...state,
        golfamoreInformation: { shown: action.payload }
      };
    case 'UNHANDLED_WEB_SALES':
      return {
        ...state,
        unhandledWebSales: { number: action.payload, fetched: Date.now() }
      };
    case 'VERSION_CHECKED':
      return {
        ...state,
        settings: {
          ...state.settings,
          // version: action.payload || state.settings.version,
          versionLastChecked: Date.now()
        }
      };
    case 'RESTRICTIONS_FETCHED':
      return {
        ...state,
        restrictions: {
          data: action.payload,
          fetched: Date.now()
        }
      };
    case 'ADMIN_CONTACT_FETCHED':
      return {
        ...state,
        adminContact: {
          data: action.payload,
          fetched: Date.now()
        }
      };
    case 'CLEAR_STORE':
      return initialState;
    default:
      return state;
  }
}

export function StoreProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, localState || initialState);
  const value = { state, dispatch };

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {
      // if (isQuotaExceeded(e)) {
      // Storage full
      // if (!localStorage.getItem('storage-full-reload')) {
      localStorage.clear();
      // localStorage.setItem('storage-full-reload', true);
      window.location.reload();
      // }
      // }
    }
  }, [state]);

  return <Store.Provider value={value}>{children}</Store.Provider>;
}
